<template>
  <div class="mini-calendar__filter-collapse">
    <input type="hidden" :value="categoryId" />
    <h3 class="mini-calendar__filter-collapse-title">
      <button
        :id="'mini-calendar__filter-' + uuid + '-section-filters-label'"
        class="mini-calendar__filter-collapse-trigger"
        :aria-controls="
          'mini-calendar__filter-' + uuid + '-section-filter-content'
        "
        :aria-expanded="(!isHidden).toString()"
        @click="toggleOpen"
      >
        <span>{{ title }}</span>
        <span class="mini-calendar__filter-collapse-trigger-icon"></span>
      </button>
    </h3>
    <div
      class="mini-calendar__filter-collapse-content"
      :id="'mini-calendar__filter-' + uuid + '-section-filter-content'"
      :aria-labelledby="
        'mini-calendar__filter-' + uuid + '-section-filters-label'
      "
      role="region"
      :aria-hidden="isHidden.toString()"
    >
      <div class="mini-calendar__filter-collapse-content-wrap text-content">
        <form
          class="mini-calendar__filter-collapse-content-wrap-inner"
          @submit.prevent
        >
          <div v-for="item in categories" :key="item.id" class="form-item">
            <template v-if="option == 'checkbox'">
              <input
              type="checkbox"
              :value="item.id"
              :id="'category_' + item.id"
              v-model="selectedbox"
              tabindex="-1"
              @change="checkbox(categoryId)"
            />
            <label :for="'category_' + item.id">{{ item.name }}</label>
            </template>
            <template v-else>
              <input
                type="radio"
                :id="'mini-calendar-' + item.id"
                :value="item.id"
                tabindex="-1"
                :checked="item.id == this.date_range.type"
                name="mini-calendar-date-filter"
                @change="checkradio"
              />
              <label :for="'mini-calendar-' + item.id">{{ item.name }}</label>
            </template>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getFilteredEvents } from "./../../api";
import { mapActions, mapGetters } from "vuex";
import { DATE_FORMAT } from "@/utils/config";
import { RouterPath } from "@/utils/mixin";
import { mapState } from "vuex";

export default {
  name: "MiniCalendarCollpase",
  mixins: [RouterPath],
  props: {
    title: String,
    uuid: String,
    categories: Array,
    categoryId: String,
    option: {
      type: String,
      default: "checkbox",
    },
    opend: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHidden: true,
      is_open: this.opend,
      selected: "",
      selectedbox: [],
      selectedCategories: {},
    };
  },
  created() {
    const queryParams = this.$route.query;
    if (this.categoryId) {
      const match = this.categoryId.match(/\d+/);
      if (match) {
        const categoryParam = `category_${match[0]}[]`;
        const urlParam = `category_${match[0]}`;
          if (queryParams[urlParam]) {
            const selectedValues = Array.isArray(queryParams[urlParam])
              ? queryParams[urlParam]
              : [queryParams[urlParam]];
            this.isHidden = false;
            this.selectedbox = selectedValues.map(String);
            // Update Vuex store with selected categories
            this.$store.dispatch("updateSelectedCategories", {
              key: categoryParam,
              terms: this.selectedbox,
            });
          }
      } else {
        console.warn(`Invalid categoryId format: ${this.categoryId}`);
      }
    }
  },
  watch: {
    filter: function (newVal) {
      this.selectedbox = newVal;
      const filtered = this.categories.filter(
        (item) => newVal.indexOf(item.id) >= 0
      );
      if (filtered.length) {
        this.is_open = true;
      }
    },
  },
  computed: {
    ...mapGetters(["date_range", "filter", "categorylist"]),
    ...mapState(["selectedCategories", "categoryKeys"]),
  },
  methods: {
    onclick() {
      this.is_open = !this.is_open;
    },
    checkradio(e) {
      const searchTerm = this.$store.getters.search || "";
      let selected = e.target.value;
      let start = "",
        end = "";

      if (selected == "today") {
        start = moment().format(DATE_FORMAT);
        end = moment().format(DATE_FORMAT);
      } else if (selected == "tomorrow") {
        start = moment().add(1, "days").format(DATE_FORMAT);
        end = moment().add(1, "days").format(DATE_FORMAT);
      } else if (selected == "week") {
        start = moment().startOf("week").format(DATE_FORMAT);
        end = moment().endOf("week").format(DATE_FORMAT);
      } else if (selected == "month") {
        start = moment().startOf("month").format(DATE_FORMAT);
        end = moment().endOf("month").format(DATE_FORMAT);
      } else if (selected == "custom_range") {
        this.setDateRange({
          type: selected,
          start: "",
          end: "",
        });
        return;
      } else {
        start = moment().format(DATE_FORMAT);
      }
      const selectedMonth = moment(start).format("YYYY-MM");
      this.setSelectedMonth(selectedMonth);

      this.setDateRange({
        type: selected,
        start: start,
        end: end,
      });

      this.setLoading(true);
      getFilteredEvents(start, end, '', 0, searchTerm)
        .then((response) => {
          if (response) {
            let data = response.data ? response.data : [];

            this.setEventList({ eventlist: data, total: response.query.total });
          }

          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    checkbox(categoryId) {
      const match = categoryId.match(/\d+/);
      const currentCategoryKey = `category_${match[0]}[]`;
      const newSelectedTerms = [...this.selectedbox];
      this.$store.dispatch("updateSelectedCategories", {
        key: currentCategoryKey,
        terms: newSelectedTerms, // Overwrite terms for this category
      });
      // query string dynamically
      const queryString = Object.entries(this.$store.state.selectedCategories)
        .flatMap(([key, terms]) =>
          terms.map((term) => `${key}=${term}`)
        )
        .join("&");
      this.setLoading(true);
      const searchTerm = this.$store.getters.search || "";
      const startDate = this.date_range.start || moment().format("YYYY-MM-DD");
      const endDate = this.date_range.end || "";

      getFilteredEvents(startDate, endDate, queryString, 1, searchTerm)
      .then((response) => {
        this.setFilter(this.selectedbox);
        if (response) {
          const data = response.data ? response.data : [];
          this.setEventList({ eventlist: data, total: response.query.total });
        }
        this.setLoading(false);
      })
      .catch(() => {
        this.setLoading(false);
      });
    },

    applyAllFilters() {
      this.setLoading(true);
      const queryString = Object.entries(this.$store.state.selectedCategories || {})
      .flatMap(([key, terms]) => terms.map((term) => `${key}=${term}`))
      .join("&");
      const filtersQueryString = queryString || "";
      const searchTerm = this.search || "";
      const currentDate = moment().format("YYYY-MM-DD");
      const startDate = this.date_range.start || currentDate;
      const endDate = this.date_range.end || "";
      const selectedMonth = moment(startDate).format("YYYY-MM");
      this.setSelectedMonth(selectedMonth);

      getFilteredEvents(startDate, endDate, filtersQueryString, 1, searchTerm)
        .then((response) => {
          if (response) {
            let data = response.data ? response.data : [];
            this.setEventList({
              eventlist: data,
              total: response.query.total,
            });
          }
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    onEnter() {
      this.setSearch({ search: this.searchValue });
      this.applyAllFilters();
    },
    toggleOpen() {
      this.isHidden = !this.isHidden;
    },

    ...mapActions([
      "setDateRange",
      "setEventList",
      "setLoading",
      "setFilter",
      "setSearch",
      "updateSelectedCategories",
      "setSelectedMonth"
   ]),
  },
};
</script>
